import { Injectable } from '@angular/core';

@Injectable()
export class LivesSessionHelper {
  private _conectia = 'conectia';
  private _a3DocToken = 'a3DocToken';
  private _environmentId = 'environmentId';
  private _aspNetUserId = 'aspNetUserId';
  private _attendance = 'attendance';
  private _companyCode = 'companyCode';
  private _klikticket = 'klikticket';
  private _livesHR = 'livesHR';
  private _hostelHR = 'hostelHR';
  private _myreportin = 'myreportin';
  private _documentData = 'documentData';
  private _livesAccessToken = 'livesAccessToken';
  private _popupCompaniesDisplayed = 'popupCompaniesDisplayed';

  public get Conectia(): string {
    return sessionStorage.getItem(this._conectia);
  }
  public set Conectia(value: string) {
    sessionStorage.setItem(this._conectia, value);
  }

  public get A3DocToken(): string {
    return sessionStorage.getItem(this._a3DocToken);
  }
  public set A3DocToken(value: string) {
    sessionStorage.setItem(this._a3DocToken, value);
  }
  public removeA3DocToken(): void {
    sessionStorage.removeItem(this._a3DocToken);
  }

  public get EnvironmentId(): string {
    return sessionStorage.getItem(this._environmentId);
  }
  public set EnvironmentId(value: string) {
    sessionStorage.setItem(this._environmentId, value);
  }

  public get AspNetUserId(): string {
    return sessionStorage.getItem(this._aspNetUserId);
  }

  public async waitForAspNetUserId(): Promise<string> { //En el login tarda en obtener el valor, este método hace que repita hasta que lo obtenga
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        const id = sessionStorage.getItem(this._aspNetUserId);
        if (id && id !== 'null') {
          clearInterval(interval);
          resolve(id);
        }
      }, 100);
    });
  }


  public set AspNetUserId(value: string) {
    sessionStorage.setItem(this._aspNetUserId, value);
  }

  public get Attendance(): string {
    return sessionStorage.getItem(this._attendance);
  }
  public set Attendance(value: string) {
    sessionStorage.setItem(this._attendance, value);
  }

  public get CompanyCode(): string {
    return sessionStorage.getItem(this._companyCode);
  }
  public set CompanyCode(value: string) {
    sessionStorage.setItem(this._companyCode, value);
  }

  public get Klikticket(): string {
    return sessionStorage.getItem(this._klikticket);
  }
  public set Klikticket(value: string) {
    sessionStorage.setItem(this._klikticket, value);
  }

  public get LivesHR(): string {
    return sessionStorage.getItem(this._livesHR);
  }
  public set LivesHR(value: string) {
    sessionStorage.setItem(this._livesHR, value);
  }

  public get HostelHR(): string {
    return sessionStorage.getItem(this._hostelHR);
  }
  public set HostelHR(value: string) {
    sessionStorage.setItem(this._hostelHR, value);
  }

  public get MyReportin(): string {
    return sessionStorage.getItem(this._myreportin);
  }
  public set MyReportin(value: string) {
    sessionStorage.setItem(this._myreportin, value);
  }

  public get DocumentData(): string {
    return sessionStorage.getItem(this._documentData);
  }
  public set DocumentData(value: string) {
    sessionStorage.setItem(this._documentData, value);
  }
  public removeDocumentData(): void {
    sessionStorage.removeItem(this._documentData);
  }

  public get LivesAccessToken(): string {
    return sessionStorage.getItem(this._livesAccessToken);
  }
  public set LivesAccessToken(value: string) {
    sessionStorage.setItem(this._livesAccessToken, value);
  }
  public hasLivesAccessToken(): boolean {
    const token = sessionStorage.getItem(this._livesAccessToken);
    return token !== null && token.trim() !== '';
  }

  public get PopupCompaniesDisplayed(): string {
    return sessionStorage.getItem(this._popupCompaniesDisplayed);
  }
  public set PopupCompaniesDisplayed(value: string) {
    sessionStorage.setItem(this._popupCompaniesDisplayed, value);
  }


}
